module.exports = __webpack_public_path__ + "static/media/home-video-trailer-MOBILE.085a0601.mp4";